<script setup lang="ts">
  /**
   * ローディングオーバーレイ
   * 使いたいコンポーネントにconst { $loadingOverlay } = useNuxtApp();で$loadingOverlayを取得する
   * オーバーレイを開く場合は、必要な操作の中に、以下のように記述する
   * $loadingOverlay.open({ message: '処理中です' });
   * 閉じる場合は $loadingOverlay.close();
   */

  export interface LoadingOverlayOptions {
    message?: string;
  }

  const isOpen = ref(false);
  const options = ref<LoadingOverlayOptions>({ message: "" });

  const open = (opts: LoadingOverlayOptions = {}) => {
    isOpen.value = true;
    options.value = { ...options.value, ...opts };
  };

  const close = () => {
    isOpen.value = false;
    options.value = { message: "" };
  };

  defineExpose({ open, close });
</script>

<template>
  <v-overlay v-model="isOpen" z-index="10000" class="align-center justify-center" scrim="black" persistent>
    <div class="item-wrapper">
      <v-progress-circular indeterminate color="primary" />
      <div class="message">{{ options.message }}</div>
    </div>
  </v-overlay>
</template>

<style lang="scss" scoped>
  .item-wrapper {
    height: 100svh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .message {
    margin-top: 16px;
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    text-align: center;
  }
</style>
